import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { Chart } from 'chart.js';
import { ProjectService } from "../Services/project.service";
import { ChartToolTipServiceService } from "../Services/chart-tool-tip-service.service";
import { MatDialog } from "@angular/material/dialog";
import { LogsDisplayModalComponent } from "../Admin/logs-display-modal/logs-display-modal.component";
import { Output, EventEmitter } from '@angular/core';

@Component({
    selector: "app-pie-chart",
    templateUrl: "./pie-chart.component.html",
    styleUrls: ["./pie-chart.component.css"],
    standalone: false
})
export class PieChartComponent implements OnInit {
  @ViewChild("myChart", { static: true })
  myChart: ElementRef<HTMLCanvasElement>;
  @ViewChild('pieChartDiv') pieChartDiv!: ElementRef;
  chart: Chart;
  @Input("data") data;
  @Input("labels") labels;
  @Input("chartData") chartData;
  @Input("display") display;
  @Input('chartType') displayType;
  @Input('_isLabel') _isLabel;
  @Input('colorScheme') chartColotrScheme;
  @Input("viewMore") viewMore;
  @Input('isDashboard') isDashboard

  _chart: Chart;
  toolTipInterval: any;
  customTooltip: any = {};
  pieChartErrNumber: any = 200;
  isdata = false
  @Output() totalHours = new EventEmitter<any>();

  constructor(private renderer: Renderer2, private _projectService: ProjectService, private _chartService: ChartToolTipServiceService, public dialog: MatDialog, public _cd: ChangeDetectorRef) {

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.createPieChart();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.createPieChart();
  }

  removePlaceholderElements() {
    const placeholders = this.pieChartDiv.nativeElement.querySelectorAll('canvas');
    for (var i = 0; i < placeholders.length; i++) {
      this.renderer.removeChild(this.pieChartDiv.nativeElement, placeholders[i]);
    }
  }

  createPieChart() {
    

    this._cd.detectChanges();
    this.data = this.labels[0] == 'No data Found' ? this.data : this.convertToMilliseconds(this.data);


    if (this.data && this.data.length > 0) {
      this.isdata = true
    } else {
      this.isdata = false
    }
    this.removePlaceholderElements();

    const canvas = this.renderer.createElement("canvas");
    // this.renderer.appendChild(
    //   document.getElementById("pieChartContainer"),
    //   canvas
    // );

    this.renderer.appendChild(
      this.pieChartDiv.nativeElement,
      canvas
    );

    // const valuesArray = [];

    // for (let i = 0; i < this.labels.length; i++) {
    //   const randomValue = Math.floor(Math.random() * 140) + 3; // Generate random value between 3 and 9
    //   valuesArray.push(randomValue);
    // }

    // this.data = []
    const ctx = canvas.getContext("2d");
    this.chart = new Chart(ctx, {
      type: this.displayType,
      data: {
        labels: this.labels.map((item) => item.substring(0,20)),
        // labels: this.labels,
        datasets: [
          {
            data: this.data,
            borderWidth: 0,
            backgroundColor: this.chartColotrScheme
          },

        ],
      },
      options: {
        responsive: true,
        plugins: {
          tooltip: {
            mode: 'index',
            enabled: true,
            intersect: false,
          },
          legend: {
            display: this._isLabel,
            position: "top",
          },
        },
      },

    });

  }



  convertToMilliseconds(timeArr) {
    let timeData = [];
    let totalHours = 0;
    for (let i = 0; i <= timeArr.length - 1; i++) {
      // if (this.isDashboard) {

      //   const timeParts = timeArr[i].split(':');
      //   const hours = parseInt(timeParts[0]);
      //   const minutes = parseInt(timeParts[1]);
      //   const seconds = parseInt(timeParts[2]);
      //   console.log('hours ---- ', hours, typeof hours)
      //   timeData.push(Number(hours.toFixed(2)));
      //   totalHours += hours;
      // } else {
      //   const milliseconds = this.timeToMilliseconds(timeArr[i]);
      //   const hours = this.millisecondsToHours(milliseconds);
      //   console.log('hours ---- ', hours, typeof hours)
      //   timeData.push(Number(hours.toFixed(2)));
      //   totalHours += hours;
      // }

      const milliseconds = this.timeToMilliseconds(timeArr[i]);
      const hours = this.millisecondsToHours(milliseconds);
      timeData.push(Number(hours.toFixed(2)));
      totalHours += hours;

      // timeData.push((hours * 3600 + minutes * 60 + seconds) * 1000);
      // timeData.push(hours);

    }
    this.totalHours.emit(totalHours.toFixed(2).replace(".00", ""));
    // Calculate milliseconds
    return timeData;
  }


  timeToMilliseconds(timeString) {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    const totalMilliseconds = (hours * 3600 + minutes * 60 + seconds) * 1000;
    return totalMilliseconds;
  }

  // Function to convert milliseconds to hours
  millisecondsToHours(milliseconds) {
    const hours = milliseconds / 3600000;
    return hours;
  }

  openLogsModal() {
    this.dialog.open(LogsDisplayModalComponent, {
      width: "calc(100vw - 20vw)",
      maxHeight: "calc(100vh - 90px)",
      height: "auto",
      // data: {
      //   user: this.userLog[index] || {},
      //   type: type,
      //   appInfo: infoData,
      //   appName:
      //     this.usedApp[index] && this.usedApp[index].appName
      //       ? this.usedApp[index].appName
      //       : {},
      // },
    });
  }

  handleButtonClick(logs, appName) {
    // Handle button click here
    // Open Application Analysis modal from here

    let type = "appInfo";

    this.dialog.open(LogsDisplayModalComponent, {
      width: type !== "appInfo" ? "1000px" : "calc(100vw - 20vw)",
      maxHeight: "calc(100vh - 90px)",
      height: "auto",
      data: {
        user: logs.logs || {},
        type: type,
        // appInfo: logs.logs[0].sessions,
        appInfo: logs.logs,
        appName: appName
      },
    });

    // alert('Open Your Modal from here');
  }

  displayFormate(time) {
    if (time) {
      if (time.split(":")[0] !== '00') {
        // When some hours
        return time.split(":")[1] !== '00' ? time.split(":")[0] + " h " + time.split(":")[1] + " m" : time.split(":")[0] + "h"
      }
      else if (time.split(":")[1] !== '00') {
        // When only minutes
        return time.split(":")[1] + " m "
      }
      else {
        return "N/A"
      }
    }
    else {
      return
    }
  }

}
